// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1Ghoo","header":"MessagesList_header__1TbF2","chat":"MessagesList_chat__3P0By"};